import { localizedPath } from '../i18n/paths'
import { useLocale } from '../i18n/LocaleProvider'
import { Link } from '../i18n/LocalizedLink'
import InfiniteTicker from './InfiniteTicker'
import { useInquiry } from './InquirySheet'
import './Footer.css'

export default function Footer() {
  const { locale, t } = useLocale()
  const { openInquiry } = useInquiry()
  const year = new Date().getFullYear()
  const ticker = `Bybeit, Inc. \u00A9 ${year} Bybeit, Inc. \u00A9 ${year} All rights reserved. All rights reserved. `

  return (
    <footer className="footer">
      {/* Kept in the DOM for an easy future restore; hidden in Footer.css. */}
      <div className="footer-tickers" aria-hidden="true">
        <div className="footer-marquee">
          <InfiniteTicker groupClassName="footer-marquee-copy" duration={25}>
            {ticker}
          </InfiniteTicker>
        </div>
        <div className="footer-marquee">
          <InfiniteTicker groupClassName="footer-marquee-copy" direction="right" duration={25}>
            {ticker}
          </InfiniteTicker>
        </div>
      </div>

      {/* Main footer */}
      <div className="footer-main">
        <div className="footer-top">
          <div className="footer-logo-wrap">
            <Link to="/">
              <img src="/lockup_footer.png" alt="Bybeit" className="footer-logo" />
            </Link>
          </div>
          <nav className="footer-nav">
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/newsroom">Newsroom</Link>
            <Link to="/company">Company</Link>
            <Link to="/configurator">Configurator</Link>
            <button type="button" onClick={() => openInquiry()}>Get in Touch</button>
          </nav>
        </div>

        <div className="footer-mid">
          <div className="footer-section">
            <span className="footer-section-title jp">{t("Help & Resources")}</span>
            <div className="footer-link-row">
              <a href={localizedPath("/company", locale)} className="jp">{t("Company")}</a>
              <Link to="/announcements" className="jp">{t("Electronic Public Notices")}</Link>
              <a href={localizedPath("/terms", locale)} className="jp">{t("Terms of Service")}</a>
              <a href={localizedPath("/privacy", locale)} className="jp">{t("Privacy Policy")}</a>
              <Link to="/status" className="jp">{t("Service Status")}</Link>
            </div>
          </div>

          <div className="footer-section">
            <span className="footer-section-title jp">{t("Follow Bybeit")}</span>
            <div className="footer-link-row">
              <a href="https://www.instagram.com/getbybeit" target="_blank" rel="noopener noreferrer">Instagram</a>
              <a href="https://www.linkedin.com/company/bybeit/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-disclaimer">
            {`\u00A9 ${year} Bybeit, Inc. All rights reserved.`}
          </p>
          <p className="footer-entity jp">{t("Bybeit, Inc.")}</p>
        </div>
      </div>

      <div className="footer-wordmark" aria-label="Enter Japan">
        <span>Enter</span>
        <span>Japan</span>
      </div>
    </footer>
  )
}
